module.exports = __webpack_public_path__ + "static/img/abyssRadar.9f3bed3f.svg";